/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import {
  FormTemplate,
  FormTemplateSection,
  FormTemplateOption,
  FormTemplateField,
} from 'data/template/template.types';
import { NodeData } from 'data/nodes/nodes.types';

export type ListenersIpAddressPortsType = {
  [key:string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'view') {
    (clonedTemplate.main as FormTemplateSection).fields.networkId.readOnly = true;
    (clonedTemplate.main as FormTemplateSection).fields.description.readOnly = true;
    (clonedTemplate.main as FormTemplateSection).fields.ownIPAddress.readOnly = true;
    (clonedTemplate.portRange as FormTemplateSection).fields.startPortNumber.readOnly = true;
    (clonedTemplate.portRange as FormTemplateSection).fields.portNumberRange.readOnly = true;
    (clonedTemplate.portRange as FormTemplateSection).fields.nodeName.readOnly = true;
  }

  return clonedTemplate;
}

export function adaptTemplateOptions(
  template: FormTemplate | undefined,
  xcipioNodes: NodeData[]
): FormTemplate | undefined {
  if (template == null) {
    return;
  }
  const clonedTemplate = cloneDeep(template);
  setOptionForTemplateSection(
    clonedTemplate.portRange as FormTemplateSection,
    getXcipioNodes(xcipioNodes),
    'nodeName'
  );

  return clonedTemplate;
}

function setOptionForTemplateSection(
  templateSection: FormTemplateSection,
  options: FormTemplateOption[],
  fieldName: string
) {
  const { fields } = templateSection;
  const templateField = fields[fieldName];
  if (templateField == null || templateField?.options == null || options == null) {
    return;
  }

  setOptionFormTemplateField(templateField, options);
}

function setOptionFormTemplateField(
  templateField: FormTemplateField,
  options: FormTemplateOption[],
) {
  if (options.length > 0) {
    templateField.options?.push(...options);
    templateField.initial = templateField.options?.[0].value;
  } else {
    templateField.initial = '';
  }
}

function getXcipioNodes(
  xcipioNodes: NodeData[]
): FormTemplateOption[] {
  return xcipioNodes?.map((field) => ({
    label: field.nodeName,
    value: field.nodeName,
  }));
}
